var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4775 0.463135C13.7676 0.463135 14.0458 0.578369 14.2509 0.783487C14.4561 0.988605 14.5713 1.2668 14.5713 1.55688V12.4944H25.5088C25.7989 12.4944 26.0771 12.6096 26.2822 12.8147C26.4873 13.0199 26.6025 13.2981 26.6025 13.5881C26.6025 13.8782 26.4873 14.1564 26.2822 14.3615C26.0771 14.5667 25.7989 14.6819 25.5088 14.6819H14.5713V25.6194C14.5713 25.9095 14.4561 26.1877 14.2509 26.3928C14.0458 26.5979 13.7676 26.7131 13.4775 26.7131C13.1875 26.7131 12.9093 26.5979 12.7041 26.3928C12.499 26.1877 12.3838 25.9095 12.3838 25.6194V14.6819H1.44629C1.15621 14.6819 0.878009 14.5667 0.672891 14.3615C0.467773 14.1564 0.352539 13.8782 0.352539 13.5881C0.352539 13.2981 0.467773 13.0199 0.672891 12.8147C0.878009 12.6096 1.15621 12.4944 1.44629 12.4944H12.3838V1.55688C12.3838 1.2668 12.499 0.988605 12.7041 0.783487C12.9093 0.578369 13.1875 0.463135 13.4775 0.463135Z",
    fill: "#242226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/accordion.8d63a92373204ddbe5ecb62eb9e59ca5.svg";
export { ForwardRef as ReactComponent };